import type { AiChatErrorCode } from "@9amhealth/shared";
import { AiChatError } from "@9amhealth/shared";

interface SimulatedError {
  code: AiChatErrorCode;
  statusCode?: number;
  persistent: boolean;
}

let config: SimulatedError | null = null;
const listeners = new Set<() => void>();

function notify(): void {
  for (const fn of listeners) {
    fn();
  }
}

export const ChatErrorSimulator = {
  set(code: AiChatErrorCode, statusCode?: number, persistent = false): void {
    config = { code, statusCode, persistent };
    notify();
  },

  clear(): void {
    config = null;
    notify();
  },

  consume(): AiChatError | null {
    if (!config) {
      return null;
    }
    const { code, statusCode, persistent } = config;
    if (!persistent) {
      config = null;
      notify();
    }
    const msg = `[Simulated] ${code}` + (statusCode ? ` (${statusCode})` : "");
    return new AiChatError(code, msg, statusCode);
  },

  get current(): SimulatedError | null {
    return config;
  },

  subscribe(fn: () => void): () => void {
    listeners.add(fn);
    return () => listeners.delete(fn);
  }
};
